import { LoadingButton } from "@mui/lab";
import { Alert, Box, Icon, Stack } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ErrorDetailContainer } from "../../../api/config";
import { ProjectDto, ProjectService } from "../../../api/psc";
import {
    DialogContainer,
    DialogHeader,
    ErrorParser,
} from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogContext";
import { updateAccess } from "../../../slices/SharedSlice";
import { createRandomId } from "../../../utils/random";

// updated
export default function SelectionPrintDialog(props: {
    projects: ProjectDto[];
}) {
    const [id, setId] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<ErrorDetailContainer | null>(null);
    const { closeDialog } = useContext(DialogContext);
    const dispatch = useDispatch();

    useEffect(() => {
        const hash = createRandomId(10);

        const projectIds = props.projects.map((p) => p.hashId);

        ProjectService.printProjects("1", {
            projectIdsHash: projectIds,
        })
            .then((r) => {
                localStorage.setItem(hash, JSON.stringify(r));
                setId(hash);

                for (const result of r) {
                    if (result.constructorViewInfo.updatedAccess) {
                        dispatch(
                            updateAccess(
                                result.constructorViewInfo.updatedAccess
                            )
                        );
                    }
                }
            })
            .catch((e: ErrorDetailContainer) => {
                setLoading(false);
                setError(e);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const closeDialogAfterDelay = () => {
        closeDialog(true);
    };

    return (
        <DialogContainer>
            <DialogHeader title="پرینت پروژه ها" />

            <Box sx={{ p: 2 }}>
                {loading ? (
                    <Alert sx={{ mb: 2 }} severity="info">
                        در حال آماده سازی پرینت
                    </Alert>
                ) : (
                    <>
                        <Alert sx={{ mb: 2 }} severity="success">
                            فایل پرینت با موفقیت ساخته شد لطفا برای مشاهده آن
                            روی گزینه زیر کلیک کنید.
                        </Alert>
                        <Alert
                            sx={{ mb: 2, textAlign: "justify" }}
                            severity="info"
                        >
                            پیشنهاد می‌کنیم پیش از پرینت گرفتن، با دیدن ویدیوی
                            زیر، شیوه‌ی استفاده‌ی بهینه‌تری را یاد گرفته و
                            استفاده‌ی بهتری از اطلاعات داشته باشید.
                        </Alert>
                    </>
                )}

                <Stack direction="column" spacing={2}>
                    {!loading && (
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href="https://persiansaze.com/wp-content/uploads/1404/onboard/tips-to-use.mp4"
                            onClick={closeDialogAfterDelay}
                        >
                            <LoadingButton
                                fullWidth
                                loading={loading}
                                color="secondary"
                                variant="contained"
                                startIcon={<Icon>movie_edit</Icon>}
                            >
                                راهنمای استفاده‌ی بهینه از پلتفرم پرشین سازه
                            </LoadingButton>
                        </a>
                    )}

                    <ErrorParser error={error} />

                    <a
                        rel="noreferrer"
                        target="_blank"
                        href={error == null ? `/print?id=${id}` : undefined}
                        onClick={closeDialogAfterDelay}
                    >
                        <LoadingButton
                            fullWidth
                            loading={loading}
                            disabled={error != null}
                            color="warning"
                            variant="outlined"
                            startIcon={<Icon>print</Icon>}
                        >
                            مشاهده و پرینت پروژه ها
                        </LoadingButton>
                    </a>
                </Stack>
            </Box>
        </DialogContainer>
    );
}
